<template>
  <Row class="header" type="flex" align="middle" justify="space-between">
    <Col class="header__left">
      <router-link to="/" class="logo">
        <img src="../assets/images/logo.svg" class="logo__img" />
        <span class="title">Личный кабинет</span>
      </router-link>
    </Col>

    <Col class="main-menu">
      <Row type="flex" align="middle" :gutter="50">
        <!-- <Col
          v-if="!user.is_client"
        >
          <router-link
            to="/timetable"
            class="title"
          >Календарь</router-link>
        </Col> -->
        <Col>
          <router-link
            :to="{ name: 'appointments' }"
            class="title"
          >
            Актуальные заявки
          </router-link>
        </Col>

        <!-- TODO: как мы теперь архивируем?
        <Col>
          <router-link
            :to="{ name: 'appointments-archive' }"
            class="title"
          >
            Архив заявок
          </router-link>
        </Col>
        -->

        <!-- TMP: 2021-07-07 Костя попросил скрыть -->
        <!-- <Col
          ><router-link to="/messages" class="title"
            >Сообщения
            <i class="dot" v-if="unreadMessages > 0">{{
              unreadMessages
            }}</i></router-link
          ></Col
        > -->
      </Row>
    </Col>

    <Col class="header__right">
      <span class="title" @click="menuHandler">
        {{ user.getFullName() }}
      </span>

      <!-- Dropdown Menu -->
      <transition name="dropdown">
        <div class="menu" v-if="menuIsVisible" v-click-outside="menuHandler">
          <router-link to="/profile" class="menu__item"
            >Редактировать аккаунт</router-link
          >
          <span class="menu__item" @click="logout">Выйти</span>
        </div>
      </transition>
    </Col>
  </Row>
</template>

<script>
import { mapGetters } from "vuex";
import MessagesService from "@/services/MessagesService";


export default {
  name: "MainHeader",

  props: {
    newAppointments: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      menuIsVisible: false,
      check: null,
      // hasUnreadMessages: false,
      messages: []
      //chatService: new ChatService()
    };
  },

  computed: {
    ...mapGetters({
      user: "user/getUser"
    }),

    unreadMessages() {
      return this.messages.length;
    },

    needToUpdateChat() {
      // no chat currently
      return false;  // this.user.is_client ? true : this.user.chat_enabled;
    }
  },

  watch: {
    needToUpdateChat(v) {
      if (!v) {
        clearInterval(this.check);
      }
      else {
        this.initNewMessageCheck();
      }
    }
  },

  async created() {
    // TODO: no chat currently
    // await this.checkUnreadMessages();
    // this.initNewMessageCheck();
  },

  beforeDestroy() {
    clearInterval(this.check);
  },

  methods: {
    logout() {
      this.$store.dispatch("authorization/logout");
      this.$router.replace("/", () => {});
    },

    menuHandler() {
      this.menuIsVisible = !this.menuIsVisible;
    },

    async checkUnreadMessages() {
      this.messages = await MessagesService.checkUnreadMessages();
    },

    initNewMessageCheck() {
      this.check = setInterval(() => this.checkUnreadMessages(), 5000);
    }

    // async checkUnreadMessages() {
    //   this.hasUnreadMessages = await this.chatService.checkUnreadMessages();
    // }
  }
};
</script>

<style lang="scss" scoped>

.header {
  background: $blue-dark;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  padding: 0 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .main-menu {
    .router-link-exact-active {
      text-decoration: underline;
    }
  }

  .title {
    color: $white;
    font-size: 18px;
    text-decoration: none;
    font-weight: 500;
    letter-spacing: 0.01em;
    position: relative;

    .dot {
      position: absolute;
      text-align: center;
      top: -10px;
      right: -20px;
      background: red;
      font-size: 12px;
      font-weight: 600;
      font-style: normal;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }

  &__left {
    .logo {
      display: flex;
      align-items: center;
      &__img {
        width: 32px;
        height: 34px;
        margin-right: 30px;
      }
    }
  }

  &__right {
    position: relative;
    .title {
      position: relative;
      padding-right: 30px;
      cursor: pointer;
      &:before {
        content: "";
        position: absolute;
        background-image: url(../assets/images/arrow.svg);
        background-repeat: no-repeat;
        background-size: auto;
        background-position: center;
        width: 8px;
        height: 100%;
        right: 0;
      }
    }

    .menu {
      background: $white;
      position: absolute;
      padding: 10px 0;
      box-shadow: $box-shadow;
      border-radius: 5px;
      right: 0;
      top: calc(100% + 30px);
      z-index: 1;
      min-width: 230px;
      &__item {
        display: block;
        padding: 10px 25px;
        cursor: pointer;
        &:hover {
          color: $blue;
        }
      }
    }
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.5s;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>
